import { createContext } from 'react';
import { initialState } from './reducer';
export var ScrollContext = createContext({
    dispatch: Function,
    renderLen: 1,
    start: 0,
    offsetStart: 0,
    rowHeight: initialState.rowHeight,
    totalLen: 0,
});
//# sourceMappingURL=context.js.map